'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _room = require('../actions/room');

var _enum = require('../enum');

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var initialState = {
  saveObject: {
    ActionMaker: 'Doctor',
    WeekDetails: [{
      DayOfWeek: 'Sunday',
      DayShifts: []
    }, {
      DayOfWeek: 'Monday',
      DayShifts: []
    }, {
      DayOfWeek: 'Tuesday',
      DayShifts: []
    }, {
      DayOfWeek: 'Wednesday',
      DayShifts: []
    }, {
      DayOfWeek: 'Thursday',
      DayShifts: []
    }, {
      DayOfWeek: 'Friday',
      DayShifts: []
    }, {
      DayOfWeek: 'Saturday',
      DayShifts: []
    }]
  },
  roomScheduleTypes: [],
  roomReservationWindow: [],
  roomLoaded: false,
  selectedScheduleType: undefined,

  addRoomResponse: undefined,
  addRoomLoadState: _enum.status.SHOULD_CALL_API,
  editRoomResponse: undefined,
  editRoomLoadState: _enum.status.SHOULD_CALL_API,
  deleteRoomResponse: undefined,
  deleteRoomLoadState: _enum.status.SHOULD_CALL_API,
  getRoomsResponse: undefined,
  getRoomsLoadState: _enum.status.SHOULD_CALL_API,
  addEditRoomModal: { roomDetails: {}, isOpen: false, isEdit: false },
  getDoctorShiftsResponse: undefined,
  getDoctorShiftsLoadState: _enum.status.SHOULD_CALL_API,
  assignDoctorShiftsToRoomResponse: undefined,
  assignDoctorShiftsToRoomLoadState: _enum.status.SHOULD_CALL_API,
  getRoomsCalendarViewResponse: undefined,
  getRoomsCalendarViewLoadState: _enum.status.SHOULD_CALL_API
};

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];

  var type = _ref.type,
      payload = _objectWithoutProperties(_ref, ['type']);

  switch (type) {
    case _room.ROOM.GET_ROOMS_CALENDAR_VIEW.FETCH:
      return _extends({}, state, {
        getRoomsCalendarViewResponse: undefined,
        getRoomsCalendarViewLoadState: _enum.status.FETCHING
      });
    case _room.ROOM.GET_ROOMS_CALENDAR_VIEW.SUCCESS:
      return _extends({}, state, {
        getRoomsCalendarViewResponse: payload.payload,
        getRoomsCalendarViewLoadState: _enum.status.SUCCESS
      });
    case _room.ROOM.GET_ROOMS_CALENDAR_VIEW.FAIL:
      return _extends({}, state, {
        getRoomsCalendarViewResponse: payload.payload,
        getRoomsCalendarViewLoadState: _enum.status.FAIL
      });
    case _room.ROOM.GET_DOCTOR_SHIFTS_ROOMS.FETCH:
      return _extends({}, state, {
        getDoctorShiftsResponse: undefined,
        getDoctorShiftsLoadState: _enum.status.FETCHING
      });
    case _room.ROOM.GET_DOCTOR_SHIFTS_ROOMS.SUCCESS:
      return _extends({}, state, {
        getDoctorShiftsResponse: payload.payload,
        getDoctorShiftsLoadState: _enum.status.SUCCESS
      });
    case _room.ROOM.GET_DOCTOR_SHIFTS_ROOMS.FAIL:
      return _extends({}, state, {
        getDoctorShiftsResponse: payload.payload,
        getDoctorShiftsLoadState: _enum.status.FAIL
      });

    case _room.ROOM.ASSIGN_DOCTOR_SHIFTS_TO_ROOMS.SUBMIT:
      return _extends({}, state, {
        assignDoctorShiftsToRoomResponse: undefined,
        assignDoctorShiftsToRoomLoadState: _enum.status.SUBMITING
      });
    case _room.ROOM.ASSIGN_DOCTOR_SHIFTS_TO_ROOMS.SUCCESS:
      return _extends({}, state, {
        assignDoctorShiftsToRoomResponse: payload.payload,
        assignDoctorShiftsToRoomLoadState: _enum.status.SUCCESS
      });
    case _room.ROOM.ASSIGN_DOCTOR_SHIFTS_TO_ROOMS.FAIL:
      return _extends({}, state, {
        assignDoctorShiftsToRoomResponse: payload.payload,
        assignDoctorShiftsToRoomLoadState: _enum.status.FAIL
      });
    case _room.ROOM.GET_ROOM_DETAILS_SUCCESS:
      {
        var roomScheduleTypesObj = {};
        var roomReservationWindowObj = {};
        if (payload.roomScheduleTypes) {
          roomScheduleTypesObj = {
            roomScheduleTypes: payload.roomScheduleTypes
          };
        }
        if (payload.roomReservationWindow && payload.roomReservationWindow.data) {
          roomReservationWindowObj = {
            roomReservationWindow: payload.roomReservationWindow.data
          };
        }
        return Object.assign({}, state, roomScheduleTypesObj, roomReservationWindowObj, {
          roomLoaded: true
        });
      }
    case _room.ROOM.FILTER_SUCCESS:
      return _extends({}, state, { saveObject: payload.days });
    case _room.ROOM.SET_ROOM_SCHEDULE_TYPES:
      return _extends({}, state, { roomScheduleTypes: payload.roomScheduleTypes });
    case _room.ROOM.SET_ROOM_RESERVATION_WINDOW:
      return _extends({}, state, { roomReservationWindow: payload.roomReservationWindow });
    case _room.ROOM.SET_SELECTED_ROOM_SCHEDULE_TYPE:
      return _extends({}, state, { selectedScheduleType: payload.selectedScheduleType });

    case _room.ROOM.ADD_ROOM.SUBMIT:
      return _extends({}, state, {
        addRoomResponse: undefined,
        addRoomLoadState: _enum.status.SUBMITING
      });
    case _room.ROOM.ADD_ROOM.SUCCESS:
      return _extends({}, state, {
        addRoomResponse: payload.payload,
        addRoomLoadState: _enum.status.SUCCESS
      });
    case _room.ROOM.ADD_ROOM.FAIL:
      return _extends({}, state, {
        addRoomResponse: payload.payload,
        addRoomLoadState: _enum.status.FAIL
      });

    case _room.ROOM.UPDATE_ROOM.SUBMIT:
      return _extends({}, state, {
        editRoomResponse: undefined,
        editRoomLoadState: _enum.status.SUBMITING
      });
    case _room.ROOM.UPDATE_ROOM.SUCCESS:
      return _extends({}, state, {
        editRoomResponse: payload.payload,
        editRoomLoadState: _enum.status.SUCCESS
      });
    case _room.ROOM.UPDATE_ROOM.FAIL:
      return _extends({}, state, {
        editRoomResponse: payload.payload,
        editRoomLoadState: _enum.status.FAIL
      });

    case _room.ROOM.DELETE_ROOM.SUBMIT:
      return _extends({}, state, {
        deleteRoomResponse: undefined,
        deleteRoomLoadState: _enum.status.SUBMITING
      });
    case _room.ROOM.DELETE_ROOM.SUCCESS:
      return _extends({}, state, {
        deleteRoomResponse: payload.payload,
        deleteRoomLoadState: _enum.status.SUCCESS
      });
    case _room.ROOM.DELETE_ROOM.FAIL:
      return _extends({}, state, {
        deleteRoomResponse: payload.payload,
        deleteRoomLoadState: _enum.status.FAIL
      });

    case _room.ROOM.GET_ROOMS.FETCH:
      return _extends({}, state, {
        getRoomsResponse: undefined,
        getRoomsLoadState: _enum.status.FETCHING
      });
    case _room.ROOM.GET_ROOMS.SUCCESS:
      return _extends({}, state, {
        getRoomsResponse: payload.payload,
        getRoomsLoadState: _enum.status.SUCCESS
      });
    case _room.ROOM.GET_ROOMS.FAIL:
      return _extends({}, state, {
        getRoomsResponse: payload.payload,
        getRoomsLoadState: _enum.status.FAIL
      });

    case _room.ROOM.TOGGLE_ADD_EDIT_ROOM_MODAL:
      return _extends({}, state, {
        addEditRoomModal: _extends({}, state.addEditRoomModal, payload.payload)
      });
    default:
      return state;
  }
};

module.exports = exports['default'];